import axiosClient from 'api/axiosClient';
import imgEmptyThanhToan from 'assets/images/img_emptyview_thanh_toan.png';
import PaymentTransactionDetailView from 'features/ManagePaymentTransactions/components/PaymentTransactionDetailView';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import DropdownTableConfigColumn2 from 'general/components/DropdownTableConfigColumn2';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSButton, { KTBSButtonSize } from 'general/components/OtherKeenComponents/KTBSButton';
import KTBSCard from 'general/components/OtherKeenComponents/KTBSCard';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import KTPagination, {
  KTPaginationColor,
} from 'general/components/OtherKeenComponents/KTPagination';
import KTTable from 'general/components/OtherKeenComponents/KTTable';
import tableStyle from 'general/components/OtherKeenComponents/KTTable/tableStyle';
import KTTooltip from 'general/components/OtherKeenComponents/KTTooltip';
import CustomDateRangePicker, {
  dateFilter,
  getDateFilterOption,
} from 'general/components/Others/CustomDateRangePicker';
import EmptyView from 'general/components/Others/EmptyView';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import ToastHelper from 'general/helpers/ToastHelper';
import Global from 'general/utils/Global';
import Utils from 'general/utils/Utils';
import useConfigTableColumn from 'hooks/useConfigTableColumn';
import useRouter from 'hooks/useRouter';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

PaymentTransactionListScreen.propTypes = {};

const defaultColumnIds = [
  'TRANSACTION_CODE',
  'USER_NAME',
  'BANK_BENEFICIARY',
  'TIME',
  'STATUS',
  'AMOUNT',
];

function PaymentTransactionListScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const { user } = useSelector((state) => state.auth);
  const fullColumns = useMemo(() => {
    return [
      {
        id: 'TRANSACTION_CODE',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Mã giao dịch')}
          </span>
        ),
        width: '160px',
        selector: (row) => row?.paymentCode ?? row?.paymentId,
        style: {
          color: AppColors.primaryActive,
          fontWeight: '600',
          fontSize: Utils.convertToFontSize(13),
        },
      },
      {
        id: 'USER_NAME',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Người rút tiền')}
          </span>
        ),
        selector: (row) => row?.agency?.name,
        style: tableStyle.columns.normal,
        minWidth: '200px',
      },
      {
        id: 'BANK_BENEFICIARY',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Người thụ hưởng')}
          </span>
        ),
        selector: (row) => row?.agency?.bankBeneficiary,
        style: tableStyle.columns.normal,
        minWidth: '200px',
      },
      {
        id: 'TIME',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Thời điểm gửi lệnh')}
          </span>
        ),
        selector: (row) => Utils.formatDateTimeToString(row?.time),
        style: tableStyle.columns.normal,
        minWidth: '180px',
      },
      {
        id: 'STATUS',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Trạng thái')}
          </span>
        ),
        selector: (row) => (
          <KTLabel
            text={t(`agencyPaymentStatus_${row?.status}`)}
            isInline={true}
            size={KTLabelSize.medium}
            additionalClassName={`label-light-${getStatusColor(row?.status)}`}
          />
        ),
        style: tableStyle.columns.normal,
        minWidth: '180px',
      },
      {
        id: 'AMOUNT',
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Số tiền (VNĐ)')}
          </span>
        ),
        selector: (row) => Utils.formatNumber(row?.amount ?? 0),
        style: tableStyle.columns.normal,
        right: true,
        minWidth: '180px',
      },
      {
        name: (
          <span
            className="letter-spacing-unset font-weight-bolder"
            style={{
              fontSize: 12,
              color: AppColors.gray[900],
            }}
          >
            {t('Phê duyệt')}
          </span>
        ),
        width: '100px',
        // center: true,
        style: {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          borderLeft: '1px solid #ebedfe',
        },
        cell: (row) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              <KTTooltip offset={[0, 0]} text={'Xem chi tiết'}>
                <a
                  className="btn btn-sm btn-clean btn-icon"
                  onClick={() => {
                    handleShowPaymentTransactionDetail(row);
                  }}
                >
                  <i
                    className="fa-regular fa-eye"
                    style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                  />
                </a>
              </KTTooltip>
              {['PROCESSING', 'REQUESTED'].includes(row?.status) ? (
                <VITableRowDropDown
                  toggleElement={
                    <a className="btn btn-sm btn-clean btn-icon p-0">
                      <i
                        className="fa-solid fa-ellipsis"
                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                      />
                    </a>
                  }
                  menuItem={[
                    {
                      iconElement: <i className="fa-solid fa-badge-check"></i>,
                      text: t('accept'),
                      click: () => {
                        handleUpdateTransactionStatus(row?.paymentId, 'PROCESSING');
                      },
                    },
                    {
                      iconElement: <i className="fa-solid fa-xmark-to-slot"></i>,
                      text: t('reject'),
                      click: () => {
                        handleUpdateTransactionStatus(row?.paymentId, 'REJECTED');
                      },
                    },
                  ]}
                />
              ) : (
                <></>
              )}
            </div>
          );
        },
      },
    ];
  }, [t]);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(Global.g_filterPaymentTransactionList);
  const statusOptions = useMemo(() => {
    return [
      { name: 'Tất cả', value: '' },
      { name: t('agencyPaymentStatus_REQUESTED'), value: 'REQUESTED' },
      { name: t('agencyPaymentStatus_PROCESSING'), value: 'PROCESSING' },
      { name: t('agencyPaymentStatus_PAID'), value: 'PAID' },
      { name: t('agencyPaymentStatus_REJECTED'), value: 'REJECTED' },
    ];
  }, [t]);

  const prefKey = useMemo(() => {
    const userId = user.userId;
    const pathName = router.pathname;
    const key = `${userId}_${pathName}`;
    return key;
  }, [user, router]);
  const [fullColumnIds, setFullColumnIds] = useState(
    fullColumns?.map((row) => row?.id).filter(Boolean) || []
  );
  const {
    columnIds,
    columns,
    onChangeCheckboxValue,
    resetDefaultTableColumn,
    onSelectAll,
    onUnSelectAll,
    fullColumnsSorted,
    fullColumnsIdSorted,
  } = useConfigTableColumn(prefKey, fullColumnIds, defaultColumnIds, fullColumns);

  useEffect(() => {
    const getPaymentTransactionList = async (params) => {
      setLoading(true);
      const res = await axiosClient.get('/agency/withdraw/requests', {
        params: Utils.filterParams(params),
      });
      const { result, requests, total } = res;
      setLoading(false);
      if (result === 'success') {
        setItems(requests);
        setTotal(total);
      }
    };

    getPaymentTransactionList(filter);
  }, [filter]);

  // MARK: ---- methods ----
  const getStatusColor = (status) => {
    switch (status) {
      case 'REQUESTED':
        return 'primary';
      case 'PROCESSING':
        return 'warning';
      case 'PAID':
        return 'success';
      case 'REJECTED':
        return 'danger';
      default:
        return 'primary';
    }
  };
  const handleUpdateTransactionStatus = async (paymentId, status) => {
    const params = {
      paymentId,
      status,
    };
    const res = await axiosClient.post('/agency/processWithdraw', params);
    const { result, reason } = res;
    if (result === 'success') {
      ToastHelper.showSuccess('Cập nhật trạng thái giao dịch thành công');
      setFilter({ ...filter });
    } else {
      ToastHelper.showError(reason ?? 'Cập nhật trạng thái giao dịch không thành công');
    }
  };

  return (
    <div>
      <KTBSCard
        borderRadius="15"
        title={t('Giao dịch rút tiền')}
        description={
          <div>
            <span className="font-weight-bolder" style={{ color: AppColors.gray[800] }}>
              {t('total')}:{' '}
            </span>
            <span style={{ color: AppColors.primary }}>
              {Utils.formatNumber(total)} {t('giao dịch').toLowerCase()}
            </span>
          </div>
        }
        additionalHeaderClassName="py-4"
        additionalBodyClassName="py-0"
        additionalFooterClassName="py-4"
        hideDividerHeader
        hideDividerFooter
        toolbar={<div className="d-flex gap-2"></div>}
        subToolbar={
          <div className="w-100 d-flex align-items-end flex-wrap">
            <div className="col-md-3 col-sm-6 pl-0 py-2">
              <label htmlFor="search" className="mb-0 mr-2 font-weight-bolder">
                {t('search')}
              </label>
              <KTFormSearch
                name="search-bar"
                placeholder={t('typeToSearch')}
                onSubmit={(text) => {
                  setFilter({
                    ...filter,
                    q: text,
                  });
                }}
              />
            </div>
            {/* trang thai */}
            <div className="col-md-3 col-sm-6 pl-0 py-2">
              <label htmlFor="status" className="mb-0 mr-2 font-weight-bolder">
                {t('Lọc theo trạng thái')}
              </label>
              <KTBSDropdown
                toggleElement={
                  <button
                    className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                    type="button"
                  >
                    {statusOptions.find((item) => item.value === filter.status)?.name}
                  </button>
                }
                selectedValue={filter.status}
                dropdownMenuItems={statusOptions}
                dropdownMenuClassName="overflow-auto w-100"
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                onChange={(value) => {
                  setFilter({
                    ...filter,
                    status: value,
                  });
                }}
                isDropdownForm={true}
              />
            </div>

            <div className="col-md-3 col-sm-6 pl-0 py-2">
              <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
                {t('Khoảng thời gian')}
              </label>
              <CustomDateRangePicker
                toggleElementBorderRadius={5}
                alignRight={true}
                initialValue={filter.dateFilter}
                onPressSave={(selectedValue, startDate, endDate) => {
                  setFilter({
                    ...filter,
                    dateFilter: selectedValue,
                    from: startDate,
                    to: endDate,
                  });
                }}
              />
            </div>

            {/* cau hinh cot */}
            <div className="pr-0 py-2">
              <DropdownTableConfigColumn2
                columnIds={columnIds}
                fullColumns={fullColumns}
                fullColumnIds={fullColumnsIdSorted}
                onChangeCheckboxValue={onChangeCheckboxValue}
                resetDefaultTableColumn={resetDefaultTableColumn}
                onChangeFullColumnIds={(ids) => {
                  setFullColumnIds(ids);
                  const key = prefKey + '_FULL_COLUMN_IDS';
                  localStorage.setItem(key, ids.join('|'));
                }}
                onSelectAll={onSelectAll}
                onUnSelectAll={onUnSelectAll}
              />
            </div>
          </div>
        }
        footer={
          <KTPagination
            currentPage={filter.page + 1}
            rowCount={total}
            rowsPerPage={filter.limit}
            currentItemInPageCount={items.length}
            onChangePage={(newPage) => {
              const iNewPage = parseInt(newPage);
              setFilter({
                ...filter,
                page: iNewPage - 1,
              });
            }}
            onChangeRowsPerPage={(newRowsPerPage) => {
              const iNewRowsPerPage = parseInt(newRowsPerPage);
              setFilter({
                ...filter,
                limit: iNewRowsPerPage,
                page: 0,
              });
            }}
            loading={loading}
            color={KTPaginationColor.success}
          />
        }
        body={
          <KTTable
            columns={columns}
            items={items}
            selectableRows={false}
            striped={false}
            compactGrid={false}
            onClickedRow={() => { }}
            onSelectedRowsChanged={(rows) => { }}
            onDoubleClickedRow={(rows) => { }}
            noDataComponent={
              <EmptyView
                icon={imgEmptyThanhToan}
                title="Không có dữ liệu để hiển thị"
                text={<span>Vui lòng kiểm tra kết nối mạng hoặc tải lại trang.</span>}
              />
            }
          />
        }
      />
    </div>
  );
}

export default PaymentTransactionListScreen;
